import { appendClassName } from '@componentLibraryWrapper/common';
import { Grid, GridProps } from '@componentLibraryWrapper/grid';
import './gridElement.scss';

export interface GridElementProps extends Omit<GridProps, 'spacing' | 'container'> {
}

const GridElement = ({
	className,
	...rest
}: GridElementProps) => {
	return (
		<Grid
			{...rest}
			className={appendClassName('sm-gridelement', className)}
		/>
	)
}

export default GridElement;